import PropTypes from 'prop-types';
import styles from './FJImageInput.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import FJToolTip from '../FJToolTip/FJToolTip';
import { useRef } from 'react';
import FJPreviewBox from '../FJPreviewBox/FJPreviewBox';
import DeleteIcon from '../../../assets/svg/delete-x-white.svg?react';
import UploadCircleIcon from '../../../assets/svg/upload-circle.svg?react';
import ReplaceIcon from '../../../assets/svg/replace.svg?react';
import DragReplaceIcon from '../../../assets/svg/drag-replace.svg?react';
import FJUtil from '../../../util/FJUtil';
import { useMemo } from 'react';

const FJImageInput = props => {
    const {
        uploadImageInfo = {},
        isDraggingFile,

        style,

        acceptFile,
        disable = false,
        isDelete = false,
        isMultiple = false,

        leftChild,

        uploadImg,
        onDelete,
        openMediaLibrary,
        setIsDraggingFile,
        id,
    } = props;
    const { src: imgSrc, name } = uploadImageInfo;

    const inputRef = useRef(null);
    const _onUploadImg = e => {
        if (disable) return;
        if (isMultiple) {
            const files = Array.from(e.target.files);
            uploadImg(files);
        } else {
            const file = e.target.files[0];
            uploadImg(file);
        }
        e.target.value = null;
    };
    const _onUpload = e => {
        e.stopPropagation();
        if (disable) {
            return;
        }

        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const _onDelete = e => {
        e.stopPropagation();
        if (disable) {
            return;
        }
        onDelete && onDelete();
    };

    const _onDragOver = e => {
        if (disable) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        if (disable) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        if (disable) return;
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);

        let files = Array.from(e.dataTransfer.files);
        if (files && files.length > 0) {
            if (isMultiple) {
                uploadImg(files);
            } else {
                const file = files[0];
                uploadImg(file);
            }
        }
    };

    const containerWidth = 327;
    const fileName = useMemo(() => {
        let { fileText } = FJUtil.getEspText(name, 13, containerWidth - 5);
        return fileText;
    }, [name]);

    return (
        <div
            className={styles.input_box}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
            style={{ height: '64px', ...style }}
            id={id}
        >
            {imgSrc ? (
                <div className={styles.img_content} onClick={_onUpload}>
                    <div className={styles.img_box}>
                        <img className={styles.img} src={imgSrc} alt='' loading='lazy' />
                        <FJPreviewBox imageInfo={uploadImageInfo} className={styles.mask} />
                    </div>
                    <div className={styles.img_info}>
                        <span className={styles.img_info_text} title={fileName === name ? '' : name}>
                            {!fileName || fileName === '' ? FJLocalStore._('image') : fileName}
                        </span>
                    </div>
                    <FJToolTip title={isDelete ? FJLocalStore._('delete') : FJLocalStore._('change-image')}>
                        <div
                            className={classNames(styles.reload_icon, disable ? styles.reload_icon_disabled : '')}
                            onClick={isDelete ? _onDelete : _onUpload}
                        >
                            {isDelete ? <DeleteIcon /> : <ReplaceIcon />}
                        </div>
                    </FJToolTip>
                </div>
            ) : (
                <div className={classNames(styles.blank, isDraggingFile && styles.dragging)} onClick={_onUpload}>
                    <div className={styles.upload_border_box}></div>

                    {/* {isDraggingFile ? <AddFileIcon /> : <UploadCircleIcon />} */}
                    <UploadCircleIcon />
                    <span className={styles.blank_text}>
                        {/* {isDraggingFile ? FJLocalStore._('drag-and-drop') : FJLocalStore._('upload-image')} */}
                        {FJLocalStore._('upload-image')}
                    </span>
                    {leftChild}
                </div>
            )}

            {isDraggingFile && imgSrc && (
                <div className={classNames(styles.filter_mask, isDraggingFile ? styles.dragging : '')}>
                    <DragReplaceIcon />
                    <span className={styles.filter_mask_text}>{FJLocalStore._('drag-and-drop')}</span>
                </div>
            )}
            <div className={styles.dragging_mask}></div>

            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={acceptFile}
                multiple={isMultiple}
                onChange={_onUploadImg}
            />
        </div>
    );
};
FJImageInput.propTypes = {
    uploadImageInfo: PropTypes.object,
    uploadImg: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    acceptFile: PropTypes.string,
    disable: PropTypes.bool,
};
export default FJImageInput;
